import { createSelector } from "reselect";
import { getKaMetlhaFuneralClaim } from "./index";
import { KMF_CLAIM_PAGE_INDICES } from "../../actions/kaMetlhaFuneralClaim/types";

export const getRouting = createSelector(
    getKaMetlhaFuneralClaim,
  (kaMetlhaFuneralClaim) => kaMetlhaFuneralClaim.routing
);
export const getActivePageIndex = createSelector(
  getRouting,
  (routing) => routing.activePageIndex
);
export const getDoNavigation = createSelector(
  getRouting,
  (routing) => routing.doNavigation
);
export const getDoExitNavigation = createSelector(
  getRouting,
  (routing) => routing.doExitNavigation
);

export const makeGetIsPage = (pageIndex) =>
  createSelector(
    getRouting,
    (routing) => routing.activePageIndex === pageIndex
  );
export const getIsDropoffPage = createSelector(
  getRouting,
  (routing) => routing.activePageIndex === 1
);

export const getIsClaimentPage = makeGetIsPage(
  KMF_CLAIM_PAGE_INDICES.CLAIMENT_DETAILS
);
export const getIsDeceasedPage = makeGetIsPage(
  KMF_CLAIM_PAGE_INDICES.DECEASED_DETAILS
);
export const getIsUplaoadDocumentsPage = makeGetIsPage(
  KMF_CLAIM_PAGE_INDICES.UPLOAD_DOCUMENTS
);

export const getProgressBarSteps= createSelector(
    getRouting,(routing)=>routing.progressBarSteps
)

// used by the application wizard footer
export const getContinueButtonText = createSelector(
  getActivePageIndex,
  (activePageIndex) => {
    return activePageIndex === KMF_CLAIM_PAGE_INDICES.UPLOAD_DOCUMENTS
      ? "SUBMIT"
      : "CONTINUE";
  }
);


// used by the application wizard header
// TODO: Implement page types and remove magic numbers
export const getHideMobile = createSelector(
  getActivePageIndex,
  (activePageIndex) => {
    return activePageIndex === 7;
  }
);
